module.exports = __webpack_public_path__ + "img/mobileResidentOffice2.c1283f9a.png";